<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">
			<label>{{ usuarioLogado }}</label>		
			<button class="p-link" @click="meusDados" title="Meus Dados">
				<span class="layout-topbar-item-text">Meus Dados</span>
				<span class="layout-topbar-icon pi pi-user"></span>
			</button>		
			<button class="p-link" @click="logout" title="Sair">
				<span class="layout-topbar-item-text">Sair</span>
				<span class="layout-topbar-icon pi pi-power-off"></span>
			</button>
		</div>
		<Menu id="overlay_menu" ref="menu" :model="itens" :popup="true" appendTo="body" style="width: 220px"/>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: ['usuarioLogado'],
	data() {
		return {
			itens: [],
		}
	},
    methods: {
		...mapActions('sessao', ['limparSessao']),
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
		},
		logout() {
			this.limparSessao();
			this.$router.push('/login');
		},
		meusDados() {
			this.$router.push('/conta/meus-dados');
		},
		toggle(event) {			
            this.$refs.menu.toggle(event);
		},		
	},
}
</script>